import type { AppState, MutationClass } from '../../../models'

export class SetFullscreenMutation implements MutationClass {
  static execute(this: void, state: AppState, fullscreen: boolean): void {
    state.fullscreen = fullscreen
  }
}
